export const InterfaceType = Object.freeze({
    DEFAULT: 'default',
    EMAIL: 'email',
    API: 'api',
    TELEGRAM: 'telegram',
    TEAMS: 'teams',
    WHATSAPP: 'whatsapp',
    PRODUCT_SUPPORT: 'product_support',
    TOOL: 'tool'
});
